document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.getElementById('country-selector-trigger');
  const popup = document.getElementById('language-popup');
  const overlay = document.getElementById('overlay');
  const euLink = document.getElementById('eu-language-link');
  const euContainers = document.querySelectorAll('.eu-language-link-container');
  const twoStepContainer = document.getElementById('two-step-language-list-container');

  // --- preserve current path/query/hash across language links (handles /es, /de, etc.) ---
  (function preservePathOnLanguageLinks() {
    // Don’t touch cart/checkout
    var path = window.location.pathname;
    if (path.startsWith('/cart') || path.startsWith('/checkout')) return;
    if (!popup) return;

    var links = popup.querySelectorAll('a.language-link[href]');
    if (!links.length) return;

    var current = new URL(window.location.href);
    var preservePath   = current.pathname;
    var preserveSearch = current.search;
    var preserveHash   = current.hash;

    // Build a set of locale roots from your links (e.g. "/es", "/de", "/fr")
    var localeRoots = new Set();
    links.forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href) return;
      try {
        var u = new URL(href, window.location.origin);
        var segs = u.pathname.replace(/^\/+|\/+$/g, '').split('/');
        if (segs[0]) {
          var looksLikeLocale = /^[a-z]{2}(-[a-z]{2})?$/i.test(segs[0]) && segs.length === 1;
          if (looksLikeLocale) localeRoots.add('/' + segs[0]);
        }
      } catch (e) {}
    });

    // Strip a leading locale prefix from a path, if present
    function stripLeadingLocale(p) {
      var cleaned = p || '/';
      var segs = cleaned.replace(/^\/+|\/+$/g, '').split('/');
      if (!segs[0]) return cleaned;

      var first = '/' + segs[0];
      if (localeRoots.has(first)) {
        segs.shift();
        return '/' + segs.join('/');
      }
      if (/^[a-z]{2}(-[a-z]{2})?$/i.test(segs[0])) { // heuristic fallback
        segs.shift();
        return '/' + segs.join('/');
      }
      return cleaned;
    }

    // >>> the part that was missing: rewrite each link <<<
    links.forEach(function (a) {
      var baseHref = a.getAttribute('href');
      if (!baseHref) return;

      try {
        var target = new URL(baseHref, window.location.origin);

        var targetSegs = target.pathname.replace(/^\/+|\/+$/g, '').split('/');
        var isTrueRoot   = target.pathname === '/' || target.pathname === '';
        var isLocaleRoot = (targetSegs.length === 1 && /^[a-z]{2}(-[a-z]{2})?$/i.test(targetSegs[0]));

        if (isTrueRoot || isLocaleRoot) {
          // Append current path without its own leading locale (if any)
          var basePath = stripLeadingLocale(preservePath);

          var head = target.pathname.replace(/\/+$/, '');
          var tail = basePath === '/' ? '/' : '/' + basePath.replace(/^\/+/, '');
          var joined = (head + tail).replace(/\/{2,}/g, '/');

          target.pathname = joined;
        }

        // Always preserve query + hash
        target.search = preserveSearch;
        target.hash   = preserveHash;

        a.setAttribute('href', target.toString());
      } catch (e) {
        console.warn('[Language Switcher] Could not rewrite link:', baseHref, e);
      }
    });
  })();
  // --- end preserve routine ---

  if (trigger) {
    trigger.addEventListener('click', function () {
      popup.classList.toggle('active');
      overlay.classList.toggle('active');
      document.body.style.overflow = popup.classList.contains('active') ? 'hidden' : 'auto';
      resetLanguageLinks();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      popup.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = 'auto';
      resetLanguageLinks();
    });
  }

  if (euLink && euContainers.length && twoStepContainer) {
    euLink.addEventListener('click', function () {
      twoStepContainer.classList.add('eu-hidden');
      twoStepContainer.classList.remove('eu-visible');

      euContainers.forEach(container => {
        container.classList.remove('eu-hidden');
        container.classList.add('eu-visible');
      });
    });
  }

  const resetLanguageLinks = () => {
    setTimeout(() => {
      if (twoStepContainer) { // guard for 1-step layout
        twoStepContainer.classList.remove('eu-hidden');
        twoStepContainer.classList.add('eu-visible');
      }
      euContainers.forEach(container => {
        container.classList.remove('eu-visible');
        container.classList.add('eu-hidden');
      });
    }, 300);
  };
});
